import script from "./ModalSorteo.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalSorteo.vue?vue&type=script&setup=true&lang=ts"

import "./ModalSorteo.vue?vue&type=style&index=0&id=5660cb3c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5660cb3c"]])

export default __exports__